import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const mfaMailIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 9.86816L13.6641 14.0928C12.6564 14.7644 11.3436 14.7644 10.3359 14.0928L4 9.86816V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V9.86816ZM20 7C20 6.44772 19.5523 6 19 6H5C4.44772 6 4 6.44772 4 7V7.46484L11.4453 12.4287C11.7811 12.6525 12.2189 12.6525 12.5547 12.4287L20 7.46484V7ZM22 17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17Z" fill="#FFFFFF"/>
</svg>`
);
